import React from 'react';
import TextBox from '../Basic/TextBox';
const ItemCounts = ({ items, placeholder, nameExt }) => {
    let parts = [];
    for (let i = 0; i < items.length / 3; i++) {
        let row = [];
        for (let j = 0; j < 3; j++) {
            if (i * 3 + j >= items.length) break;
            row.push(
                <div key={i * 3 + j}>
                    <div className="col-sm-2 col-md-1" >
                        <TextBox name={items[i * 3 + j].name+(nameExt||"")} placeholder={placeholder} />
                    </div>
                    <div className="col-sm-2 padding-top-5">{items[i * 3 + j].name}</div>
                </div>
            );
        }
        parts.push(<div className="form-group" key={`${i}row`}><div className="row">{row}</div></div>);
    }
    return (
        <div>{parts}</div>
    );
};
ItemCounts.propTypes = {
    items: React.PropTypes.array,
    placeholder: React.PropTypes.string,
    nameExt: React.PropTypes.string,
};
export default ItemCounts; 